import { Box, Grid, Collapse, Card } from "@mui/material";

import FilterItems from "./FilterItems";
import ActiveFilters from "../../../Components/filters/ActiveFilters";

const Filter = ({
  filterOpen,
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  handleRemove,
  submittedData,
}) => {
  // All filters in the order they appear
  const activeFilterDefinitions = [
    // Standard filters - in order
    {
      type: "standard",
      id: "bay",
      label: "Bay",
      value: submittedData.bay,
    },
    {
      type: "standard",
      id: "isLive",
      label: "Order Live",
      value: submittedData.isLive,
    },
  ];

  return (
    <Grid item xs={12}>
      <Collapse in={filterOpen}>
        <Card>
          <Box p={4}>
            <FilterItems
              filterData={filterData}
              handleChangeFilter={handleChangeFilter}
              handleFilter={handleFilter}
              handleClearFilters={handleClearFilters}
            />
          </Box>
        </Card>
      </Collapse>

      <ActiveFilters
        filterDefinitions={activeFilterDefinitions}
        onRemoveFilter={handleRemove}
      />
    </Grid>
  );
};

export default Filter;
